import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Button, InputNumber } from 'shared';
function AccessOfferEstimateCalculatorForm({ onSubmit, isFetching, paymentFrequency, financedAmount, intendedAmountCallback, }) {
    const [transactionAmount, setTransactionAmount] = useState('');
    const handleSubmit = () => {
        onSubmit({
            financedAmount: transactionAmount,
        });
    };
    const MIN_TRANSACTION_AMOUNT = 300;
    useEffect(() => {
        if (intendedAmountCallback) {
            intendedAmountCallback(transactionAmount);
        }
    }, [transactionAmount]);
    return (_jsxs("div", { className: "access-offer-estimate-calculator", children: [_jsx(InputNumber, { label: "Intended Transaction Amount: ", labelnote: _jsxs(_Fragment, { children: ["\u00A0", _jsx("sup", { children: "\u2020" }), " \u00A0"] }), datatestid: "transaction-amount", type: "text", preicon: "$", isAllowed: (values) => {
                    const { value } = values;
                    return value.length < 18;
                }, value: transactionAmount, onChange: (e) => setTransactionAmount(e.target.value) }), _jsx("br", {}), _jsx(Button, { type: "button", onClick: handleSubmit, className: "button-warn-outline", pristine: isFetching ||
                    !paymentFrequency ||
                    !transactionAmount ||
                    Number(transactionAmount) < MIN_TRANSACTION_AMOUNT ||
                    Number(transactionAmount) > financedAmount, submitting: isFetching, "data-testid": "access-offer-calculate-button", disabledToolTip: `Transaction amount must be between $300 and the pre-qualified amount of $${financedAmount}.`, children: "Estimate Payment" })] }));
}
export default AccessOfferEstimateCalculatorForm;
